interface IToCState {
  show: boolean;
}

const actions = {
  SHOW: 'lms-ui/toc/SHOW',
};

interface IToCAction {
  type: typeof actions.SHOW;
  payload?: boolean;
}

type ToCActionTypes = IToCAction;

const initialState: IToCState = {
  show: true,
};

export const showToC = (show?: boolean): ToCActionTypes => {
  return { type: actions.SHOW, payload: show };
};

export default function reducer(state = initialState, action: ToCActionTypes): IToCState {
  switch (action.type) {
    case actions.SHOW: {
      return {
        ...state,
        show: !!action.payload,
      };
    }
    default:
      return state;
  }
}
